import React from 'react';
import Slider from "./Slider";
import Products from "../pages/Products";

const Home = () => {
    return (
        <div>
            <Slider/>
            <Products/>
        </div>
    );
};

export default Home;
